import { isArray, isEmpty } from 'lodash-es';
import { formatQuarterYear } from '../../../../utils/date';

const decoratedSpotlights = (data) =>
  data.map((item) => {
    const { confidence, trend, read } = item.spotlights;
    return {
      _raw: item,
      ...item,
      confidence,
      trend: trend.tag,
      read: read.tag,
      correlation_date: formatQuarterYear(item.correlation_date),
      va_kpi_id: item.va_kpi_id?.toString(),
    };
  });

export const companyDataTransformResponse = (data) => (isEmpty(data) ? {} : data);

export const kpiSpotlightTransformResponse = (data) => {
  if (isArray(data)) {
    // Kpi Forecasts
    if (data[0]?.forecasts) {
      return { forecasts: data };
    }

    // Kpi Spotlight
    if (data[0]?.spotlights) {
      return {
        spotlights: decoratedSpotlights(data),
      };
    }
  }

  return {};
};

export const mpiSpotlightTransformResponse = (data) => {
  if (isArray(data)) {
    // Kpi Spotlight
    if (data[0]?.spotlights) {
      return {
        mpi_spotlight: decoratedSpotlights(data),
      };
    }
  }

  return {};
};

export const driversTransformResponse = (data) => data?.drivers.data.base || {};

export const pubContributionTransformResponse = (data) => (isEmpty(data) ? {} : data);
